import { ComboBoxModel } from "@genexus/chameleon-controls-library";
import { GxOption } from "../../../../../components";

export const foldersToComboBoxModel = (
  foldersModel: GxOption[]
): ComboBoxModel =>
  foldersModel.map(folder => ({
    value: folder.name,
    caption:
      folder.name === "All" ? "All Modules" : folder.label || folder.name || ""
  }));
